// extracted by mini-css-extract-plugin
module.exports = {"homePage":"styles_homePage__SdikA","game_container":"styles_game_container__6Nw_E"};